/** @format */
import { LinkProps as FeatherLinkProps } from '@mpb-com/feather/components/atoms/link';

export {
    LinkColor,
    LinkElementType,
    LinkSize,
    LinkTarget,
    LinkVariant,
} from '@mpb-com/feather/components/atoms/link';

export type { StyledLinkProps } from '@mpb-com/feather/components/atoms/link';

export type LinkProps = FeatherLinkProps & {
    'data-testid'?: string;
    'aria-label'?: string;
};
